<template>
    <div style="height: 100vh;" class="bg-pattern d-flex justify-center align-center">
        <v-row class="ma-0">
            <v-col cols="12" sm="10" md="9" lg="8" xl="7" class="mx-auto">
                <v-card 
                    elevation="0" 
                    class="rounded-xl register-card"
                    style="background: rgba(255, 255, 255, 0.98); backdrop-filter: blur(10px);">
                    <v-card-text class="pa-3 pa-sm-4 pa-md-5">
                        <v-stepper v-model="step" elevation="0" alt-labels class="modern-stepper">
                            <template v-slot:default="{ prev, next }">
                                <v-stepper-header class="pa-0 mb-4" style="box-shadow: none;">
                                    <v-stepper-item 
                                        class="stepper-item-custom" 
                                        :value="1"
                                        :complete="step > 1">
                                        <template v-slot:icon>
                                            <v-icon size="18">fa:fa-solid fa-house</v-icon>
                                        </template>
                                        <template v-slot:title>
                                            <small class="stepper-title">Bienvenida</small>
                                        </template>
                                    </v-stepper-item>
                                    
                                    <v-divider class="stepper-divider"></v-divider>
                                    
                                    <v-stepper-item 
                                        class="stepper-item-custom" 
                                        :value="2"
                                        :complete="step > 2">
                                        <template v-slot:icon>
                                            <v-icon size="18">fa:fa-solid fa-user-check</v-icon>
                                        </template>
                                        <template v-slot:title>
                                            <small class="stepper-title">Confirma tus datos</small>
                                        </template>
                                    </v-stepper-item>
                                    
                                    <v-divider class="stepper-divider"></v-divider>
                                    
                                    <v-stepper-item 
                                        class="stepper-item-custom" 
                                        :value="3"
                                        :complete="step > 3">
                                        <template v-slot:icon>
                                            <v-icon size="18">fa:fa-solid fa-key</v-icon>
                                        </template>
                                        <template v-slot:title>
                                            <small class="stepper-title">Contraseña</small>
                                        </template>
                                    </v-stepper-item>
                                </v-stepper-header>

                                <v-stepper-window class="stepper-window-custom">
                                    <v-stepper-window-item :value="1" :key="1">
                                        <div class="welcome-section pa-3 pa-md-4 text-center">
                                            <v-avatar 
                                                size="60" 
                                                style="background: linear-gradient(135deg, #2553b9 0%, #1e88e5 100%); box-shadow: 0 3px 12px rgba(37, 83, 185, 0.3); margin-bottom: 1rem;">
                                                <v-icon :style="{ color: 'white', fontSize: '28px' }">fa:fa-solid fa-ticket</v-icon>
                                            </v-avatar>
                                            
                                            <h2 style="color: #2553b9; font-size: 1.5rem; font-weight: 700; margin-bottom: 0.75rem;">
                                                ¡Bienvenido al Sistema de Tickets!
                                            </h2>
                                            
                                            <p style="color: #616161; font-size: 0.9rem; max-width: 500px; margin: 0 auto 1rem auto; line-height: 1.6;">
                                                ¡Hola y bienvenido! Este es el primer paso para acceder a nuestro 
                                                Sistema de Tickets. Completa el formulario para comenzar.
                                            </p>
                                            
                                            <v-divider style="margin: 1rem 0;"></v-divider>
                                            
                                            <div class="d-flex flex-wrap justify-center gap-3">
                                                <v-chip 
                                                    color="primary" 
                                                    variant="tonal" 
                                                    size="small">
                                                    <v-icon :style="{ fontSize: '14px', marginRight: '4px' }">fa:fa-solid fa-check</v-icon>
                                                    Rápido
                                                </v-chip>
                                                <v-chip 
                                                    color="success" 
                                                    variant="tonal" 
                                                    size="small">
                                                    <v-icon :style="{ fontSize: '14px', marginRight: '4px' }">fa:fa-solid fa-shield</v-icon>
                                                    Seguro
                                                </v-chip>
                                                <v-chip 
                                                    color="info" 
                                                    variant="tonal" 
                                                    size="small">
                                                    <v-icon :style="{ fontSize: '14px', marginRight: '4px' }">fa:fa-solid fa-headset</v-icon>
                                                    Soporte
                                                </v-chip>
                                            </div>
                                        </div>
                                    </v-stepper-window-item>

                                    <v-stepper-window-item :value="2" :key="2">
                                        <form-register-user-component
                                            @validateFormEvent="handleEventRegister"></form-register-user-component>
                                    </v-stepper-window-item>

                                    <v-stepper-window-item :value="3" :key="3">
                                        <form-new-password-component></form-new-password-component>
                                    </v-stepper-window-item>
                                </v-stepper-window>

                                <v-divider style="margin: 1rem 0;"></v-divider>

                                <div class="d-flex justify-space-between align-center px-1">
                                    <v-btn 
                                        elevation="0"
                                        :disabled="step == 1" 
                                        @click="prev"
                                        variant="outlined"
                                        color="grey-darken-1"
                                        size="default">
                                        <v-icon :style="{ fontSize: '16px', marginRight: '4px' }">fa:fa-solid fa-arrow-left</v-icon>
                                        Anterior
                                    </v-btn>
                                    
                                    <v-btn 
                                        elevation="0"
                                        :loading="loadingregisteruser" 
                                        :disabled="step == 3"
                                        @click="next" 
                                        v-if="step != 2"
                                        color="primary"
                                        size="default">
                                        Siguiente
                                        <v-icon :style="{ fontSize: '16px', marginLeft: '4px' }">fa:fa-solid fa-arrow-right</v-icon>
                                    </v-btn>
                                    
                                    <v-btn 
                                        elevation="0"
                                        :loading="loadingregisteruser"
                                        :disabled="!validateFormRegister" 
                                        @click="saveAndContinue()"
                                        v-if="step == 2"
                                        color="primary"
                                        size="default">
                                        <v-icon :style="{ fontSize: '16px', marginRight: '4px' }">fa:fa-solid fa-save</v-icon>
                                        Guardar y Continuar
                                    </v-btn>
                                </div>

                            </template>
                        </v-stepper>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import FormRegisterUserComponent from '../components/FormRegisterUserComponent.vue';
import FormNewPasswordComponent from '../components/FormNewPasswordComponent.vue'
import { mapState, mapActions } from 'vuex';
export default {
    components: {
        FormRegisterUserComponent,
        FormNewPasswordComponent
    },
    data() {
        return {
            items: [
                'Bienvenida',
                'Confirmar datos personales'
            ],
            step: 1,
            validateFormRegister: true
        }
    },

    computed:
    {
        ...mapState('usuarios', ['loadingregisteruser'])
    },

    methods: {
        ...mapActions('login', ['getDataRegister']),
        ...mapActions('usuarios', ['createUserInvitado']),
        handleEventRegister(validate) {
            this.validateFormRegister = validate
        },
        async saveAndContinue() {
            try {
                await this.createUserInvitado()
                this.step = 3
            }
            catch (error) {
                console.log(error)
            }
        }
    },

    mounted() { 
        this.getDataRegister({ email: this.$route.params.email, password: this.$route.params.dni, microsoft: this.$route.params.microsoft? true : false })
    }
}
</script>


<style scoped>
.register-card {
    box-shadow: 0 6px 30px rgba(37, 83, 185, 0.12) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.register-card:hover {
    box-shadow: 0 8px 35px rgba(37, 83, 185, 0.18) !important;
}

.modern-stepper {
    background: transparent !important;
}

.stepper-item-custom {
    transition: all 0.3s ease;
}

.stepper-title {
    font-size: 0.75rem;
    font-weight: 600;
    color: #616161;
}

.v-stepper-item--selected .stepper-title {
    color: #2553b9;
}

.v-stepper-item--complete .stepper-title {
    color: #4caf50;
}

.stepper-divider {
    margin: 0 6px;
    border-color: #e0e0e0;
}

.stepper-window-custom {
    margin: 0;
    min-height: 280px;
    display: flex;
    align-items: center;
}

.welcome-section {
    animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.gap-3 {
    gap: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .stepper-title {
        font-size: 0.7rem;
    }
    
    .stepper-window-custom {
        min-height: 250px;
    }
}

@media (max-width: 600px) {
    .stepper-title {
        display: none;
    }
    
    .stepper-window-custom {
        min-height: 220px;
    }
}

/* Stepper animations */
.v-stepper-window-item {
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(8px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>